import Appsignal from "@appsignal/javascript";
import { conf } from './env';
import packageInfo from '../../package.json';

export const appsignal = new Appsignal({
	key: conf.appsignal,
	revision: packageInfo?.version,
	namespace: 'Community',
});